<!-- <button
  class="prev-auction"
  (click)="prevAuction()">

  &#60;
</button>

<button
  class="next-auction"
  (click)="nextAuction()">

  &#62;
</button> -->

<h1>CryptoPunk</h1>

<h2>
  @if (activeAuction.punkId !== '-1') {
    <a
      [routerLink]="['/details', activeAuction.punkId]"
      [href]="'/details/' + activeAuction.punkId">

      {{ ((activeAuction.punkId || '0000') | number : '4.0')?.replace(',', '') }}
    </a>
  } @else {
    0000
  }
</h2>

<!-- <pre>{{ activeAuction | json }}</pre> -->

@if (activeAuction.owner) {
  <div class="owned-by-wrapper">
    <span>Owned by</span>
    <a
      [routerLink]="['/', 'user', activeAuction.owner]"
      [href]="'/user/' + activeAuction.owner">

      <app-wallet-address [address]="activeAuction.owner" />
    </a>
  </div>
}

<!-- {{ punkAttributes | json }} -->
@if (punkAttributes.length) {
  <div class="one-of-label">
    One of <span class="pink">{{ traits[punkAttributes[0]] || 0 }}</span> {{ punkAttributes[0] || '????' }} punks
  </div>

  <div class="trait-count-label">
    <span class="pink">
      {{ punkAttributes.length ? punkAttributes.length - 1 : 0 }}
    </span> trait{{ punkAttributes.length - 1 > 1 ? 's' : '' }}
  </div>
}

<div class="trait-wrapper">
  <ng-container
    *ngFor="let trait of punkAttributes; let i = index">

    @if (i) {
      <div class="trait">
        <span class="pink">{{ trait }} </span>{{ ((traits[trait]) / 10000) | percent : '1.1-1' }}
      </div>
    }
  </ng-container>
</div>
